import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';
import { EvaluacionResultadoCoevaluacionDetDTO } from '../../../../core/models/evaluacion/evaluacionResultadoCoevaluacionDet-DTO';
import { BodyResponse } from '../../../../core/models/general/body-response';

const API_URL = environment.apiUrlEvaluacion;

@Injectable()
export class EvaluacionResultadoCoevaluacionDetService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getEvaluacionResultadoCoevaluacionDetService() {
        return this.http.get<BodyListResponse<EvaluacionResultadoCoevaluacionDetDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionDet/todos'
        );
    }

    guardarEvaluacionResultadoCoevaluacionDetService(evaluacionResultadoCoevaluacionDetDTO: EvaluacionResultadoCoevaluacionDetDTO) {
        return this.http.post(API_URL + '/api/v1/resultadoCoevaluacionDet', evaluacionResultadoCoevaluacionDetDTO);
    }

    getEvaluacionResultadoCoevaluacionDetPorCodigoResultadoDetService(codigoResultadoDet: String) {
        return this.http.get<BodyResponse<EvaluacionResultadoCoevaluacionDetDTO>>(
            API_URL + '/api/v1/resultadoCoevaluacionDet/' + codigoResultadoDet
        );
    }
}
